export default "__VITE_ASSET__Bjk8CgM6__"